import { ICredentials, IToken, ITokenPayload } from '../entities/credentials.entity';

interface ICredentialsDatasource {
    getCredentials(): ICredentials | null;
}

class CredentialsDatasource implements ICredentialsDatasource {

    /**
     * ?
     */
    public getCredentials(): ICredentials | null {

        const { token } = this;

        return (
            token && {
                token: token.value,
                issuedAt: new Date(token.payload.iss),
                expiresAt: new Date(token.payload.exp),
                tokenType: token.type,
                sessionId: token.payload.SessionID,
                user: {
                    id: token.payload.UserID,
                    cblc: token.payload.CBLC,
                    role: token.payload.role,
                    type: token.payload.PersonType,
                    firstName: token.payload.nameid,
                },
            }
        );
    }

    /**
     * ?
     */
    private get token(): IToken | null {

        const value = (document.cookie.split('hub$user$payload=')[1] || '').split(';')[0];
        const encodedPayload = value.split('.')[1];
        const payload = JSON.parse(atob(encodedPayload)) as ITokenPayload;

        return typeof payload === 'object' ? { type: 'Bearer', value, payload } : null;

    }

}

export const credentialsDatasource: ICredentialsDatasource = new CredentialsDatasource();
